import Backbone from 'backbone';
import CartItemView from './cartItemView';
import selectors from './selectors';

const { table } = selectors;

// The cart items list view.
class CartItemsView extends Backbone.View {

	initialize() {
		this.$el = $(table.content);
		this.collection.on('add', this.addOne, this);
		this.collection.on('reset', this.addAll, this);
		this.collection.on('sort', this.addAll, this);
	}

	render() {
		this.addAll();
		return this;
	}

	addAll() {
		setTimeout(() => {
			this.$el = $(table.content);
			this.$el.empty();
			this.collection.forEach(this.addOne, this);
		}, 20);
	}

	addOne(item) {
		const row = new CartItemView({ model: item }).render().el;
		this.$el.append(row);
	}
}

export default CartItemsView;
